<template>
  <main :class="['v-view-primary',
    $store.getters.getAcademyData.persona === undefined
      ? 'v-view-primary-upgrade' : '']">
    <OrganismTheHeader/>
    <OrganismNotFound/>
  </main>
</template>

<script>
export default {
  name: 'NotFound',

  components: {
    OrganismNotFound: () => import('@/components/organisms/OrganismNotFound')
  }
}
</script>
